/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerContractsLockState } from '../../models/customer-contracts-lock-state';

export interface GetCustomerContractsLock$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;
}

export function getCustomerContractsLock(http: HttpClient, rootUrl: string, params: GetCustomerContractsLock$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerContractsLockState>> {
  const rb = new RequestBuilder(rootUrl, getCustomerContractsLock.PATH, 'get');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerContractsLockState>;
    })
  );
}

getCustomerContractsLock.PATH = '/svgs/{svgId}/customers/{customerId}/lock-customer-contracts';
